import { $ } from './../../helpers/query';

export default () => {

  $('.building').each(section => {

    const floors = $('[data-floor]');
    const tableFloors = $('.building__table [data-floor]');
    const floorSides = $('[data-floor-side]');
    const tableFloorSides = $('.building__table [data-floor-side]');
    const tableFoot = $('.table__foot');

    tableFloors.on('mouseenter', (e, floor) => {
      const number = +floor.getAttribute('data-floor');
      const units = floor.dataset.units;
      const unitsNumbers = units.split(',');
     
      unitsNumbers.forEach(unitNumber => {
        const unit = document.querySelector(`[data-unit='${unitNumber}']`);
        unit.classList.add('hover');
      })
      
      floors.each(floorIn => {
        const numberIn = +floorIn.getAttribute('data-floor');
        if (numberIn > number) {
          floorIn.classList.add('up');
        }
      })
    });

    tableFloors.on('mouseleave', () => {
      floors.removeClass('up');

      const hovered = document.querySelectorAll('.building .hover');

      hovered.forEach(hoveredEl => {
        hoveredEl.classList.remove('hover');
      })
    });

    // tableFloorSides.on('mouseenter', (e, floorSide) => {
    //   const number = +floorSide.closest('[data-floor]').getAttribute('data-floor');
    //   const side = floorSide.getAttribute('data-floor-side');
    //   floorSides.each(floorSideIn => {
    //     const numberIn = +floorSideIn.closest('[data-floor]').getAttribute('data-floor');
    //     const sideIn = floorSideIn.getAttribute('data-floor-side');
    //     if (numberIn == number && side == sideIn) {
    //       floorSideIn.classList.add('hover');
    //     }
    //   })
    // });

    // tableFloorSides.on('mouseleave', () => {
    //   floorSides.removeClass('hover');
    // });

    if(tableFoot) {
      tableFoot.on('mouseenter', () => {
        $('.building__plan [data-floor-side]').addClass('hover');
      })
  
      tableFoot.on('mouseleave', () => {
        $('.building__plan [data-floor-side]').removeClass('hover');
      })
    }

    // tableFloors.on('click', (e, floor) => {
    //   $('#building-modal').addClass('modal--opened');
    // });

    const numbers = $('[data-number]');
    const totals = $('[data-total]');

    let totFT = 0, totM = 0;

    numbers.each(number => {
      const num = +removeTxt(number.innerHTML, ',');
      if (number.getAttribute('data-number') == 'ft') {
        totFT += num;
      } else {
        totM += num;
      }
    });

    totals.each(total => {
      if (total.getAttribute('data-total') == 'ft') {
        total.innerHTML = addTxtFromEnd(totFT.toFixed(0), ',', 3);
      } else {
        total.innerHTML = addTxtFromEnd(totM.toFixed(0), ',', 3);
      }
    });

  });

  $('[data-modal-close]').on('click', (e, btn) => {
    $(btn).closest('.modal').classList.remove('modal--opened');
  });
}

function removeTxt(text, extraSym) {
  const textLetters = text.split('');
  textLetters.forEach((letter, i) => {
    if (letter == extraSym) {
      textLetters.splice(i, 1);
    }
  });
  return textLetters.join('');
}

function addTxtFromEnd(text, newSym, position) {
  const textLetters = text.split('');
  textLetters.splice(-position, 0, newSym);
  return textLetters.join('');
}

function replace(text, inputSym, outputSym) {
  const textLetters = text.split('');
  textLetters.forEach((letter, i) => {
    if (letter == inputSym) {
      textLetters[i] = outputSym;
    }
  });
  return textLetters.join('');
}